import { OfferResponse, PartnerPageResponse } from '@/api/generated'
import { Post } from '@/business/post/models/post'
import { emptyPageResponse, PageResponse } from '@/shared/interfaces/page-response'

export interface OfferViewModel {
  offer: OfferResponse
  partners: PartnerPageResponse
  posts: PageResponse<Post>
}

export const EmptyOfferViewModel: OfferViewModel = {
  offer: {
    audiences: [],
    categories: [],
    hasReport: false,
    id: -1,
    name: '',
    organisation: {
      categories: [],
      id: -1,
      name: '',
    },
    partners: [],
    reportIsPublished: false,
    resources: [],
  },

  partners: emptyPageResponse(),
  posts: emptyPageResponse(),
}
